import useBgPages from '../../hooks/use-bg-pages.hook';
import ChannelOrTemplatePanel from '../../components/cards/panel.component';

const TemplatesPannel: React.FC = () => {
  useBgPages();

  const templates = [
    {
      to: '/templates-panel/templates-rcs',
      type: 'Plantillas',
      title: 'RCS',
      description:
        'Crea plantillas para tus envios RCS, con tarjetas enriquecidas, carrouseles y más.',
      logoSrc: '/assets/media/logos/rcs-logo.png',
      imageHeader: true,
      srcImage: 't-rcs'
    },
    {
      to: '/templates-panel/accounts-wa',
      type: 'Plantillas',
      title: 'WhatsApp',
      description:
        'Crea tus plantillas para tus envíos WhatsApp, envía imágenes, videos, documentos y más.',
      logoSrc: '/assets/media/logos/whatsapp.png',
      imageHeader: true,
      srcImage: 't-wa'
    },
    {
      to: '/templates-panel/templates-mailing',
      type: 'Plantillas',
      title: 'Correo',
      description:
        'Crea tus plantillas para tus envíos de correo electrónico, con imágenes, botones y más.',
      logoSrc: '/assets/media/logos/mail-logo.webp',
      imageHeader: true,
      srcImage: 't-email'
    }
  ];

  const links = [
    { to: '/templates-panel/templates-rcs', label: 'RCS', icon: 'ki-messages' },
    { to: '/templates-panel/accounts-wa', label: 'WhatsApp', icon: 'ki-whatsapp' }
  ];

  return (
    <ChannelOrTemplatePanel
      title={'Panel de plantillas'}
      subtitle={
        <p className="fs-6 text-dark flex-grow-1 pe-4 pt-4">
          Para tus envíos de RCS y WhatsApp, necesitarás plantillas que podrás <br />
          utilizar estratégicamente con tus clientes, y podrás enviarlas tantas veces necesites.
        </p>
      }
      items={templates}
      links={links}
    />
  );
};

export default TemplatesPannel;
